(function(){
  const root = document.querySelector('#wapp-widget-root');
  if (!root) return;

  let attempts = 0;
  const maxAttempts = 20;
  
  function initWidget() {
    if (window.whatsappChatSettings || attempts >= maxAttempts) {
      startWidget();
    } else {
      attempts++;
      setTimeout(initWidget, 100);
    }
  }
  
  function startWidget() {
    const settings = window.whatsappChatSettings || {
      phone: '8613800138000',
      label: 'Contact Us',
      bgColor: '#25D366',
      textColor: '#ffffff',
      iconUrl: '',
      position: 'right-bottom',
      buttonSize: 56,
      buttonSizeMobile: 56,
      iconSize: 24,
      iconSizeMobile: 24,
      fontSize: 15,
      delay: 3,
      scrollTrigger: 30,
      pulseAnimation: true,
      showBubble: true,
      workingHoursEnabled: true,
      workingStart: '09:00',
      workingEnd: '18:00',
      offlineMessage: 'Working hours 9:00-18:00',
      welcomeMessage: 'Hello',
      prefillMode: 'auto',
      customMessage: 'Hello',
      quickRepliesEnabled: true,
      quickReplies: ['Inquiry', 'Tracking', 'After-sales', 'Wholesale'],
      cartInfo: true,
      showProductPicker: true,
      showButton: true
    };

    let productUrl = location.href;
    let cartItems = '';
    let recentProducts = [];
    let selectedProduct = null;
    let bubbleVisible = false;
    let hasScrolled = false;
    let hasInteracted = localStorage.getItem('wapp_interacted') === 'true';
    let pageProducts = [];
    let localStorageProducts = [];
    let allProducts = [];

    function detectCurrentProduct() {
      let product = null;
      const productData = document.querySelector('[itemtype="http://schema.org/Product"]');
      if (productData) {
        const titleEl = productData.querySelector('[itemprop="name"]');
        const imageEl = productData.querySelector('[itemprop="image"]');
        const priceEl = productData.querySelector('[itemprop="price"]');
        if (titleEl) {
          product = {
            title: titleEl.textContent.trim(),
            url: productUrl,
            image: imageEl ? (imageEl.src || imageEl.content || '') : '',
            price: priceEl ? (priceEl.content || priceEl.textContent || '').replace(/[^0-9.]/g, '') : ''
          };
        }
      }
      if (!product && window.location.pathname.includes('/products/')) {
        const titleEl = document.querySelector('h1.product-title, h1.product__title, .product-single__title, h1[class*="product"]');
        const imageEl = document.querySelector('.product-single__photo img, .product__main-photos img, img[class*="product"][class*="image"]');
        const priceEl = document.querySelector('.product-price, .product__price, [class*="product"][class*="price"]');
        if (titleEl) {
          product = {
            title: titleEl.textContent.trim(),
            url: productUrl,
            image: imageEl ? imageEl.src : '',
            price: priceEl ? priceEl.textContent.trim().replace(/[^0-9.]/g, '') : ''
          };
        }
      }
      return product;
    }

    function detectPageProducts() {
      const products = [];
      const selectors = [
        '.product-card',
        '.product-item',
        '.grid-product',
        '.collection-product',
        '.product-grid-item',
        '.product',
        '[class*="product-card"]',
        '[class*="product-item"]',
        '[class*="grid-item"]',
        '.card-wrapper',
        '.grid__item'
      ];
      
      let productCards = [];
      for (let i = 0; i < selectors.length; i++) {
        const found = document.querySelectorAll(selectors[i]);
        if (found.length > 0) {
          productCards = found;
          break;
        }
      }
      
      if (productCards.length === 0) {
        const allLinks = document.querySelectorAll('a[href*="/products/"]');
        const cardElements = [];
        allLinks.forEach(function(link) {
          let parent = link.parentElement;
          let depth = 0;
          while (parent && depth < 5) {
            if (parent.querySelector('img') && parent.querySelector('a[href*="/products/"]')) {
              if (!cardElements.includes(parent)) {
                cardElements.push(parent);
              }
              break;
            }
            parent = parent.parentElement;
            depth++;
          }
        });
        productCards = cardElements;
      }
      
      productCards.forEach(function(card) {
        const link = card.querySelector('a[href*="/products/"]');
        if (!link) return;
        
        const titleSelectors = [
          '.product-title',
          '.product__title',
          '.card__heading',
          'h3',
          'h2',
          'h4',
          '[class*="title"]',
          '[class*="heading"]'
        ];
        
        let title = null;
        for (let i = 0; i < titleSelectors.length; i++) {
          const el = card.querySelector(titleSelectors[i]);
          if (el && el.textContent.trim()) {
            title = el;
            break;
          }
        }
        
        if (!title) {
          const linkText = link.textContent.trim();
          if (linkText && linkText.length > 0 && linkText.length < 100) {
            title = { textContent: linkText };
          }
        }
        
        if (!title) return;
        
        const image = card.querySelector('img');
        
        const priceSelectors = [
          '.price',
          '.product-price',
          '.product__price',
          '[class*="price"]',
          '.money'
        ];
        
        let price = null;
        for (let i = 0; i < priceSelectors.length; i++) {
          const el = card.querySelector(priceSelectors[i]);
          if (el && el.textContent.trim()) {
            price = el;
            break;
          }
        }
        
        const product = {
          title: title.textContent.trim(),
          url: link.href,
          image: image ? (image.src || image.dataset.src || '') : '',
          price: price ? price.textContent.trim().replace(/[^0-9.]/g, '') : ''
        };
        
        if (!products.find(function(p) { return p.url === product.url; })) {
          products.push(product);
        }
      });
      
      return products;
    }

    selectedProduct = detectCurrentProduct();
    pageProducts = detectPageProducts();

    // 通过 Shopify AJAX API 获取全站所有产品
    function fetchAllProducts() {
      fetch('/collections/all/products.json?limit=250')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.products && data.products.length > 0) {
            allProducts = data.products.map(function(product) {
              return {
                title: product.title,
                url: window.location.origin + '/products/' + product.handle,
                image: product.featured_image || (product.images && product.images[0] ? product.images[0].src : ''),
                price: (product.price / 100).toFixed(2)
              };
            });
            rebuildBubble();
          }
        })
        .catch(function() {});
    }
    fetchAllProducts();

    function rebuildBubble() {
      const oldBubble = document.querySelector('#wapp-bubble');
      if (oldBubble) {
        oldBubble.remove();
      }
      if (oldBubble) {
        const newBubble = buildBubble();
        root.appendChild(newBubble);
        if (bubbleVisible) {
          newBubble.classList.add('show');
          newBubble.style.display = 'block';
          attachBubbleEvents();
        }
      }
    }

    if (settings.cartInfo || settings.showProductPicker) {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (cart.items && cart.items.length > 0) {
            cartItems = '\n\nCart Items:\n' + cart.items.map(function(item) {
              return '- ' + item.product_title + ' x' + item.quantity;
            }).join('\n');
            
            recentProducts = cart.items.map(function(item) {
              return {
                title: item.product_title,
                url: window.location.origin + item.url,
                image: item.image,
                price: (item.price / 100).toFixed(2)
              };
            });
            
            rebuildBubble();
          }
        })
        .catch(function() {});
    }

    // 从 localStorage 获取最近浏览商品，补充到 pageProducts 中
    if (settings.showProductPicker) {
      try {
        var viewedHandles = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
        if (viewedHandles.length > 0) {
          viewedHandles.forEach(function(handle) {
            fetch('/products/' + encodeURIComponent(handle) + '.js')
              .then(function(r) { return r.json(); })
              .then(function(product) {
                if (!product || !product.title) return;
                var prod = {
                  title: product.title,
                  url: window.location.origin + '/products/' + product.handle,
                  image: product.featured_image || '',
                  price: (product.price / 100).toFixed(2)
                };
                var exists = false;
                for (var j = 0; j < localStorageProducts.length; j++) {
                  if (localStorageProducts[j].url === prod.url) { exists = true; break; }
                }
                if (!exists) localStorageProducts.push(prod);
                rebuildBubble();
              })
              .catch(function() {});
          });
        }
      } catch(e) {}
    }

    function isMobile() {
      return window.innerWidth <= 520;
    }

    function isWorkingHours() {
      if (!settings.workingHoursEnabled) return true;
      const now = new Date();
      const currentTime = now.getHours() * 60 + now.getMinutes();
      const startParts = settings.workingStart.split(':');
      const endParts = settings.workingEnd.split(':');
      const startH = parseInt(startParts[0]);
      const startM = parseInt(startParts[1]);
      const endH = parseInt(endParts[0]);
      const endM = parseInt(endParts[1]);
      const startTime = startH * 60 + startM;
      const endTime = endH * 60 + endM;
      return currentTime >= startTime && currentTime <= endTime;
    }

    function whatsappSVG() {
      return '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>';
    }

    function sendSVG() {
      return '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    function openWhatsapp(customText, product) {
      const number = settings.phone.replace(/[^0-9]/g, '');
      if (!number) {
        alert('Please configure WhatsApp number in settings');
        return;
      }
      
      let text = '';
      if (customText && customText.trim()) {
        text = customText;
      } else if (product && product.title) {
        text = 'Hi! I want to inquire about: ' + product.title;
        if (product.url) text += '\nLink: ' + product.url;
        if (product.price) text += '\nPrice: ¥' + product.price;
      } else {
        text = settings.customMessage || 'Hi! I want to inquire';
      }
      
      if (!product && settings.cartInfo && cartItems) {
        text += cartItems;
      }
      
      const encoded = encodeURIComponent(text);
      window.open('https://wa.me/' + number + '?text=' + encoded, '_blank');
      
      localStorage.setItem('wapp_interacted', 'true');
      hasInteracted = true;
      
      const bubble = document.querySelector('#wapp-bubble');
      if (bubble) {
        bubble.classList.remove('show');
        bubble.style.display = 'none';
        bubbleVisible = false;
      }
    }

    function toggleBubble() {
      if (!settings.showBubble) {
        openWhatsapp('', null);
        return;
      }
      
      bubbleVisible = !bubbleVisible;
      if (bubbleVisible) {
        // 每次打开时重建气泡，确保包含最新的购物车和浏览数据
        rebuildBubble();
        const bubble = document.querySelector('#wapp-bubble');
        if (bubble) {
          bubble.classList.add('show');
          bubble.style.display = 'block';
          attachBubbleEvents();
        }
      } else {
        const bubble = document.querySelector('#wapp-bubble');
        if (bubble) {
          bubble.classList.remove('show');
          bubble.style.display = 'none';
        }
      }
    }
    window.wappToggleBubble = toggleBubble;
    function attachBubbleEvents() {
      const bubble = document.querySelector('#wapp-bubble');
      if (!bubble) return;
      
      const closeBtn = bubble.querySelector('.close-btn');
      if (closeBtn) {
        closeBtn.onclick = function() {
          bubble.classList.remove('show');
          bubble.style.display = 'none';
          bubbleVisible = false;
        };
      }
      
      const sendBtn = bubble.querySelector('.send-btn');
      if (sendBtn) {
        sendBtn.onclick = function() {
          const msgInput = bubble.querySelector('#wapp-msg');
          const msg = msgInput ? msgInput.value : '';
          const selectedItem = bubble.querySelector('.product-item.selected');
          let product = null;
          
          if (selectedItem) {
            try {
              const productData = selectedItem.getAttribute('data-product');
              if (productData) product = JSON.parse(productData);
            } catch(e) {}
          }
          
          if (msg && msg.trim()) {
            openWhatsapp(msg, product);
          } else {
            openWhatsapp('', product);
          }
        };
      }
      
      const quickBtns = bubble.querySelectorAll('.quick-reply-btn');
      for (let i = 0; i < quickBtns.length; i++) {
        quickBtns[i].onclick = function() {
          const selectedItem = bubble.querySelector('.product-item.selected');
          let product = null;
          
          if (selectedItem) {
            try {
              const productData = selectedItem.getAttribute('data-product');
              if (productData) product = JSON.parse(productData);
            } catch(e) {}
          }
          
          const replyText = this.getAttribute('data-reply');
          if (product && product.title) {
            let combinedMsg = replyText + '\n\nProduct: ' + product.title;
            if (product.url) combinedMsg += '\nLink: ' + product.url;
            if (product.price) combinedMsg += '\nPrice: ¥' + product.price;
            openWhatsapp(combinedMsg, null);
          } else {
            openWhatsapp(replyText, null);
          }
        };
      }
      
      const productItems = bubble.querySelectorAll('.product-item');
      for (let i = 0; i < productItems.length; i++) {
        productItems[i].onclick = function() {
          const allItems = bubble.querySelectorAll('.product-item');
          for (let j = 0; j < allItems.length; j++) {
            allItems[j].classList.remove('selected');
          }
          this.classList.add('selected');
        };
      }
    }

    function buildBtn() {
      const btn = document.createElement('div');
      btn.id = 'wapp-floating-btn';
      
      const mobile = isMobile();
      const btnSize = mobile ? settings.buttonSizeMobile : settings.buttonSize;
      const iconSize = mobile ? settings.iconSizeMobile : settings.iconSize;
      const pos = settings.position || 'right-bottom';
      
      let positionStyles = '';
      
      if (mobile) {
        if (pos === 'left-bottom') {
          positionStyles = 'left:16px;right:auto;bottom:16px;top:auto;';
        } else if (pos === 'left-middle') {
          positionStyles = 'left:16px;right:auto;top:50%;bottom:auto;transform:translateY(-50%);';
        } else if (pos === 'right-middle') {
          positionStyles = 'right:16px;left:auto;top:50%;bottom:auto;transform:translateY(-50%);';
        } else {
          positionStyles = 'right:16px;left:auto;bottom:16px;top:auto;';
        }
      } else {
        if (pos === 'left-bottom') {
          positionStyles = 'left:24px;right:auto;bottom:24px;top:auto;';
        } else if (pos === 'left-middle') {
          positionStyles = 'left:24px;right:auto;top:50%;bottom:auto;transform:translateY(-50%);';
        } else if (pos === 'right-middle') {
          positionStyles = 'right:24px;left:auto;top:50%;bottom:auto;transform:translateY(-50%);';
        } else {
          positionStyles = 'right:24px;left:auto;bottom:24px;top:auto;';
        }
      }
      
      btn.style.cssText = 'position:fixed;z-index:99998;display:flex;align-items:center;justify-content:center;border-radius:50%;box-shadow:0 8px 20px rgba(0,0,0,0.15);cursor:pointer;transition:all 0.3s ease;opacity:0;width:' + btnSize + 'px;height:' + btnSize + 'px;background:' + settings.bgColor + ';color:' + settings.textColor + ';' + positionStyles;
      
      if (settings.pulseAnimation && !hasInteracted) {
        btn.classList.add('pulse');
      }
      
      btn.innerHTML = '<span class="wapp-icon" style="width:' + iconSize + 'px;height:' + iconSize + 'px;display:flex;align-items:center;justify-content:center">' + (settings.iconUrl ? '<img src="' + settings.iconUrl + '" style="width:100%;height:100%;object-fit:contain" alt="WhatsApp"/>' : whatsappSVG()) + '</span>';
      
      btn.onclick = function() {
        toggleBubble();
        btn.classList.remove('pulse');
      };
      
      return btn;
    }

    function buildBubble() {
      const wrap = document.createElement('div');
      wrap.id = 'wapp-bubble';
      
      const mobile = isMobile();
      const pos = settings.position || 'right-bottom';
      
      wrap.style.position = 'fixed';
      wrap.style.zIndex = '99999';
      wrap.style.borderRadius = '16px';
      wrap.style.boxShadow = '0 12px 48px rgba(0,0,0,0.15)';
      wrap.style.overflow = 'hidden';
      wrap.style.background = '#fff';
      wrap.style.display = 'none';
      
      if (mobile) {
        wrap.style.left = '12px';
        wrap.style.right = '12px';
        wrap.style.bottom = '80px';
        wrap.style.top = 'auto';
        wrap.style.maxHeight = 'calc(100vh - 100px)';
        wrap.style.overflowY = 'auto';
        wrap.style.webkitOverflowScrolling = 'touch';
        wrap.style.transform = 'none';
      } else {
        wrap.style.minWidth = '320px';
        wrap.style.maxWidth = '380px';
        
        if (pos === 'right-bottom') {
          wrap.style.right = '24px';
          wrap.style.bottom = '100px';
          wrap.style.left = 'auto';
          wrap.style.top = 'auto';
        } else if (pos === 'left-bottom') {
          wrap.style.left = '24px';
          wrap.style.bottom = '100px';
          wrap.style.right = 'auto';
          wrap.style.top = 'auto';
        } else if (pos === 'right-middle') {
          wrap.style.right = '100px';
          wrap.style.top = '50%';
          wrap.style.transform = 'translateY(-50%)';
          wrap.style.left = 'auto';
          wrap.style.bottom = 'auto';
        } else if (pos === 'left-middle') {
          wrap.style.left = '100px';
          wrap.style.top = '50%';
          wrap.style.transform = 'translateY(-50%)';
          wrap.style.right = 'auto';
          wrap.style.bottom = 'auto';
        }
      }
      
      const isOffline = !isWorkingHours();
      
      let productPickerHTML = '';
      if (settings.showProductPicker) {
        const products = [];
        
        if (selectedProduct && selectedProduct.title) {
          products.push(selectedProduct);
        }
        
        for (let i = 0; i < recentProducts.length; i++) {
          const prod = recentProducts[i];
          let found = false;
          for (let j = 0; j < products.length; j++) {
            if (products[j].url === prod.url) {
              found = true;
              break;
            }
          }
          if (!found) products.push(prod);
        }
        
        for (let i = 0; i < allProducts.length; i++) {
          const prod = allProducts[i];
          let found = false;
          for (let j = 0; j < products.length; j++) {
            if (products[j].url === prod.url) {
              found = true;
              break;
            }
          }
          if (!found) products.push(prod);
        }
        
        for (let i = 0; i < pageProducts.length; i++) {
          const prod = pageProducts[i];
          let found = false;
          for (let j = 0; j < products.length; j++) {
            if (products[j].url === prod.url) {
              found = true;
              break;
            }
          }
          if (!found) products.push(prod);
        }
        
        for (let i = 0; i < localStorageProducts.length; i++) {
          const prod = localStorageProducts[i];
          let found = false;
          for (let j = 0; j < products.length; j++) {
            if (products[j].url === prod.url) {
              found = true;
              break;
            }
          }
          if (!found) products.push(prod);
        }
        
        const displayProducts = products;
        
        if (displayProducts.length > 0) {
          let productListHTML = '';
          for (let i = 0; i < displayProducts.length; i++) {
            const prod = displayProducts[i];
            productListHTML += '<div class="product-item ' + (i === 0 ? 'selected' : '') + '" data-product=\'' + JSON.stringify(prod).replace(/'/g, '&apos;') + '\'>';
            if (prod.image) {
              productListHTML += '<img src="' + prod.image + '" alt="' + prod.title + '" class="product-img"/>';
            }
            productListHTML += '<div class="product-info"><div class="product-name">' + prod.title + '</div>';
            if (prod.price) {
              productListHTML += '<div class="product-price">¥' + prod.price + '</div>';
            }
            productListHTML += '</div><div class="product-check">✓</div></div>';
          }
          productPickerHTML = '<div class="product-picker"><div class="product-picker-title">Select product (' + displayProducts.length + ')</div><div class="product-list">' + productListHTML + '</div></div>';
        }
      }
      
      let quickRepliesHTML = '';
      if (settings.quickRepliesEnabled && settings.quickReplies.length > 0) {
        let quickBtnsHTML = '';
        for (let i = 0; i < settings.quickReplies.length; i++) {
          const reply = settings.quickReplies[i];
          quickBtnsHTML += '<button class="quick-reply-btn" data-reply="' + reply + '">' + reply + '</button>';
        }
        quickRepliesHTML = '<div class="quick-replies">' + quickBtnsHTML + '</div>';
      }
      
      wrap.innerHTML = '<header><div class="header-content"><div class="avatar">' + (settings.iconUrl ? '<img src="' + settings.iconUrl + '" style="width:28px;height:28px;object-fit:contain" alt="WhatsApp"/>' : whatsappSVG()) + '</div><div><div style="font-weight:700;font-size:16px">WhatsApp</div><div style="font-size:13px;opacity:0.9">' + (isOffline ? 'Offline' : 'Online') + '</div></div></div><button class="close-btn" aria-label="Close">×</button></header><div class="body"><div class="welcome-msg">' + settings.welcomeMessage + '</div>' + (isOffline ? '<div class="offline-notice">⏰ ' + settings.offlineMessage + '</div>' : '') + productPickerHTML + quickRepliesHTML + '<textarea id="wapp-msg" placeholder="Type a message..." aria-label="Message"></textarea><button class="send-btn" style="background:' + settings.bgColor + ';color:' + settings.textColor + '">' + sendSVG() + '<span>Send</span></button></div>';
      
      return wrap;
    }

    function showButton() {
      const btn = document.querySelector('#wapp-floating-btn');
      if (btn) {
        btn.style.opacity = '1';
        btn.classList.add('show');
      }
    }

    function handleScroll() {
      if (hasScrolled) return;
      const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      if (scrollPercent >= settings.scrollTrigger) {
        hasScrolled = true;
        showButton();
        window.removeEventListener('scroll', handleScroll);
      }
    }

    function render() {
      root.innerHTML = '';
      if (settings.showButton !== false) {
        root.appendChild(buildBtn());
      }
      if (settings.showBubble) {
        root.appendChild(buildBubble());
        attachBubbleEvents();
      }
      if (settings.showButton === false) {
        // 浮动按钮隐藏时，仍显示气泡弹窗供 Contact 按钮使用
        if (!settings.showBubble) return;
        setTimeout(showButton, 100);
        return;
      }
      if (settings.scrollTrigger > 0) {
        window.addEventListener('scroll', handleScroll);
        setTimeout(function() {
          if (!hasScrolled) showButton();
        }, settings.delay * 1000 + 5000);
      } else {
        setTimeout(showButton, settings.delay * 1000);
      }
    }

    render();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWidget);
  } else {
    initWidget();
  }
})();

